import React from "react";
import MyNavbar from "../components/Navbar/MyNavbar";
import PricePlan from "../components/PricePlan/PricePlan";

export default function PricePlanPage() {
  return (
    <div>
      <MyNavbar />
      <PricePlan />
    </div>
  );
}
